export const NFT_EMBED_URLS = {
  1: 'https://nftembed.org',
  5: 'https://goerli-nft-torrent.nftembed.org',
};
